import React from "react"
import Link from "gatsby-link"
import {
    Centered,
    // SvgIcon
} from "../../simple";

import {
    Container,
    Row,
    Col
} from "reactstrap"

import styles from "./style.module.css"

const Copyright = () => (
    <small className="text-secondary">Copyright © {new Date().getFullYear()} Ethronsoft - All Rights Reserved</small>
)

const Disclaimers = () => (
    <Link to="/policies"><small>Use Policies</small></Link>
)

//HIDE SOCIALS until we have active social pages
// const Socials = () => (
//     <div>
//         <a href="" className="px-2"><SvgIcon name="facebook" height="16px" /></a>
//         <a href="" className="px-2"><SvgIcon name="twitter" width="16px" /></a>
//         <a href="" className="px-2"><SvgIcon name="discord-2" width="16px" /></a>
//     </div>
// )

export default () => (
    <Container className={`${styles.body} fillScreen d-flex flex-column justify-content-between`}>
        <div />
        <Centered>
            <h2 className="mb-4">We Are Game</h2>
            <section>
                <p>Indie to the core, our only objective is to engineer Art, <br /> without compromise</p>
            </section>
        </Centered>
        <Row className="pt-1 pb-1">
            <Col className="d-flex justify-content-start">
                <Copyright />
            </Col>
            <Col className="d-flex justify-content-end">
                <Disclaimers />
            </Col>
            {/* <Col className="d-flex justify-content-end">
                <Socials />
            </Col> */}
        </Row>
    </Container>
)


// WEBPACK FOOTER //
// ./src/components/complex/About/index.js